// extracted by mini-css-extract-plugin
module.exports = {"icon":"PeriodDropdown_icon__1VkPd","popover":"PeriodDropdown_popover__1yIsF"};